// card-product-links.js - Manages clickable elements in product cards

(function() {
  // Only define DEBUG_CARD_CLICKS if it doesn't already exist in the global scope
  if (typeof window.DEBUG_CARD_CLICKS === 'undefined') {
    // Set to true for debug logging
    window.DEBUG_CARD_CLICKS = false;
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    initCardProductLinks();
    
    // Also initialize when Shopify sections are loaded dynamically
    document.addEventListener('shopify:section:load', function() {
      initCardProductLinks();
    });
  });

  function initCardProductLinks() {
    // 1. Make the product cards' media area clickable
    makeMediaAreaClickable();
    
    // 2. Make card content clickable (except buttons, links, forms)
    improveCardContentClickability();
    
    // 3. Ensure all interactive elements prevent event propagation
    preventPropagationOnInteractiveElements();
    
    // 4. Add a direct link to the entire card as a fallback
    addCardWrapperClickability();
    
    // 5. Add direct click handling to all image elements
    makeImagesClickable();
    
    // Debug message to confirm initialization
    debugLog('Card product links initialized');
  }

  // Utility for debug logging
  function debugLog(message, data) {
    if (!window.DEBUG_CARD_CLICKS) return;
    
    if (data) {
      console.log(`[Card Links Debug] ${message}`, data);
    } else {
      console.log(`[Card Links Debug] ${message}`);
    }
  }

  // Utility function to navigate to product page
  function goToProductPage(url) {
    if (!url) {
      debugLog('No URL provided for navigation');
      return;
    }
    
    debugLog('Navigating to:', url);
    
    // Use direct window.location for most reliable redirect
    window.location.href = url;
  }

  // Directly make all product images clickable
  function makeImagesClickable() {
    document.querySelectorAll('.product-card-wrapper .media img').forEach(function(img) {
      // Skip if already initialized
      if (img.hasAttribute('data-clickable-initialized')) return;
      img.setAttribute('data-clickable-initialized', 'true');
      
      // Find the product URL
      const card = img.closest('.product-card-wrapper');
      if (!card) return;
      
      const productUrl = card.getAttribute('data-product-url');
      if (!productUrl) return;
      
      // Set cursor and add click handler
      img.style.cursor = 'pointer';
      
      img.addEventListener('click', function(e) {
        debugLog('Product image clicked', {
          target: e.target,
          url: productUrl
        });
        
        // Don't navigate if part of an interactive area
        if (
          e.target.closest('.card__arrow') || 
          e.target.closest('button') || 
          e.target.closest('a') || 
          e.target.closest('.quick-add')
        ) {
          debugLog('Click on interactive element - not redirecting');
          return;
        }
        
        // Prevent default behavior and propagation
        e.preventDefault();
        e.stopPropagation();
        
        // Go to product page
        goToProductPage(productUrl);
      });
    });
  }

  // Make the card media (image) area clickable
  function makeMediaAreaClickable() {
    document.querySelectorAll('.card__media').forEach(function(mediaArea) {
      // Skip if already initialized
      if (mediaArea.hasAttribute('data-clickable-initialized')) return;
      mediaArea.setAttribute('data-clickable-initialized', 'true');
      
      const card = mediaArea.closest('.product-card-wrapper');
      if (!card) return;
      
      // Find product URL from the card content
      const cardContent = card.querySelector('.clickable-card-content');
      if (!cardContent) return;
      
      const productUrl = cardContent.getAttribute('data-product-url') || card.getAttribute('data-product-url');
      if (!productUrl) return;
      
      // Add the URL to media area data attribute for reference
      mediaArea.setAttribute('data-product-url', productUrl);
      
      // Make media area clickable with proper cursor
      mediaArea.style.cursor = 'pointer';
      
      // Add click event listener
      mediaArea.addEventListener('click', function(e) {
        debugLog('Media area clicked', {
          target: e.target,
          currentTarget: e.currentTarget,
          url: productUrl
        });
        
        // Don't navigate if clicking on arrows or any interactive element
        if (
          e.target.closest('.card__arrow') || 
          e.target.closest('button') || 
          e.target.closest('a') || 
          e.target.closest('form') ||
          e.target.closest('.quick-add')
        ) {
          debugLog('Click on interactive element inside media area - not redirecting');
          return;
        }
        
        // Redirect to product page
        goToProductPage(productUrl);
      });
    });
  }

  // Add clickability to the entire card wrapper as a fallback
  function addCardWrapperClickability() {
    document.querySelectorAll('.product-card-wrapper').forEach(function(card) {
      // Skip if already initialized
      if (card.hasAttribute('data-clickable-initialized')) return;
      card.setAttribute('data-clickable-initialized', 'true');
      
      // Find product URL from content or from the card itself
      let productUrl = card.getAttribute('data-product-url');
      
      // If not directly on card, try to find it from content
      if (!productUrl) {
        const cardContent = card.querySelector('.clickable-card-content');
        if (cardContent) {
          productUrl = cardContent.getAttribute('data-product-url');
        }
      }
      
      if (!productUrl) return;
      
      // Store URL on card itself
      card.setAttribute('data-product-url', productUrl);
      
      // Add a low-priority click handler to the entire card
      card.addEventListener('click', function(e) {
        debugLog('Card wrapper clicked', {
          target: e.target,
          currentTarget: e.currentTarget,
          url: productUrl
        });
        
        // Only navigate if clicking on the card itself or non-interactive elements
        // We use the most comprehensive check here
        if (
          e.target.closest('a') || 
          e.target.closest('button') || 
          e.target.closest('.quick-add') || 
          e.target.closest('.card__arrow') ||
          e.target.closest('modal-opener') ||
          e.target.closest('form') ||
          e.target.tagName === 'INPUT' ||
          e.target.tagName === 'SELECT')
        {
          debugLog('Click on interactive element inside card - not redirecting');
          return;
        }
        
        // This is a direct click on the card or a non-interactive element
        goToProductPage(productUrl);
      });
    });
  }

  // Improve card content clickable area behavior
  function improveCardContentClickability() {
    document.querySelectorAll('.clickable-card-content').forEach(function(cardContent) {
      // Skip if already initialized
      if (cardContent.hasAttribute('data-clickable-initialized')) return;
      cardContent.setAttribute('data-clickable-initialized', 'true');
      
      const productUrl = cardContent.getAttribute('data-product-url');
      if (!productUrl) return;
      
      cardContent.addEventListener('click', function(e) {
        debugLog('Card content clicked', {
          target: e.target,
          currentTarget: e.currentTarget,
          url: productUrl
        });
        
        // Don't navigate if clicking on interactive elements
        if (
          e.target.closest('a') || 
          e.target.closest('button') || 
          e.target.closest('.quick-add') || 
          e.target.closest('.card__arrow') ||
          e.target.closest('modal-opener') ||
          e.target.closest('form') ||
          e.target.tagName === 'INPUT' ||
          e.target.tagName === 'SELECT'
        ) {
          debugLog('Click on interactive element inside content - not redirecting');
          return;
        }
        
        // Redirect to product page
        goToProductPage(productUrl);
      });
      
      // Update cursor
      cardContent.style.cursor = 'pointer';
    });
  }

  // Explicitly prevent event propagation on all interactive elements
  function preventPropagationOnInteractiveElements() {
    // Target all interactive elements inside product cards
    const selectors = [
      '.card__arrow--left',
      '.card__arrow--right',
      '.card__content a',
      '.card__content button',
      '.card__media a',
      '.card__media button',
      '.quick-add button',
      '.product-card-wrapper form',
      '.product-card-wrapper input',
      '.product-card-wrapper select',
      '.card__add-to-cart-btn'
    ];
    
    // Join selectors and query all matching elements
    document.querySelectorAll(selectors.join(', ')).forEach(function(element) {
      // Skip if already initialized
      if (element.hasAttribute('data-propagation-initialized')) return;
      element.setAttribute('data-propagation-initialized', 'true');
      
      // Add click listener to stop propagation
      element.addEventListener('click', function(e) {
        debugLog('Interactive element clicked - stopping propagation', {
          element: e.currentTarget
        });
        e.stopPropagation();
      });
    });
  }
})(); 